import type { PaymentFrequency } from "@krea/shared/types/common";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./Select";

interface IPaymentFrequencySelectProps {
  name: string;
  value: PaymentFrequency;
  onChange: (value: PaymentFrequency) => void;
  onBlur: () => void;
  isSubmitting: boolean;
  options: { value: PaymentFrequency; label: string }[];
  placeholder: string;
}

/**
 * Radix fires no blur of its own, so `onBlur` is driven off the popover
 * closing — without it validation never runs on a field the user opened and
 * dismissed.
 */
export const PaymentFrequencySelect = ({
  name,
  value,
  onChange,
  onBlur,
  isSubmitting,
  options,
  placeholder,
}: IPaymentFrequencySelectProps) => (
  <Select
    value={String(value ?? "")}
    onValueChange={(v) => onChange(v as PaymentFrequency)}
    onOpenChange={(open) => {
      if (!open) {
        onBlur();
      }
    }}
    disabled={isSubmitting}
    required
  >
    <SelectTrigger id={name}>
      <SelectValue placeholder={placeholder} />
    </SelectTrigger>
    <SelectContent>
      {options.map((opt) => (
        <SelectItem key={opt.value} value={opt.value}>
          {opt.label}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);
